import { SharedLocale, type SharedLocalizedString } from "./SharedLocale.js";
import { sameValueForEverySharedLocale } from "../utils/sameValueForEverySharedLocale.js";

export const referenceUseCaseLabels: Record<string, SharedLocalizedString> = {
	picking: {
		[SharedLocale.cs]: "Vychystávání",
		[SharedLocale.en]: "Picking",
		[SharedLocale.pl]: "Kompletacja",
		[SharedLocale.sk]: "Vychystávanie",
	},
	pickToLight: sameValueForEverySharedLocale("Pick-to-light"),
	connectionToConveyor: {
		[SharedLocale.cs]: "Napojení na dopravník",
		[SharedLocale.en]: "Connection to conveyor",
		[SharedLocale.pl]: "Podłączenie do taśmy",
		[SharedLocale.sk]: "Pripojenie na dopravník",
	},
	productionLine: sameValueForEverySharedLocale("Production line"),
	automation: {
		[SharedLocale.cs]: "Automatizace",
		[SharedLocale.en]: "Automation",
		[SharedLocale.pl]: "Automatyzacja",
		[SharedLocale.sk]: "Automatizácia",
	},
	robotization: {
		[SharedLocale.cs]: "Robotizace",
		[SharedLocale.en]: "Robotization",
		[SharedLocale.pl]: "Robotyzacja",
		[SharedLocale.sk]: "Robotizácia",
	},
	customization: {
		[SharedLocale.cs]: "Customizace",
		[SharedLocale.en]: "Customization",
		[SharedLocale.pl]: "Dostosowanie",
		[SharedLocale.sk]: "Prispôsobenie",
	},
};

export const referenceScopeLabels: Record<string, SharedLocalizedString> = {
	automotive: sameValueForEverySharedLocale("Automotive"),
	fashion: sameValueForEverySharedLocale("Fashion"),
	logistics: {
		[SharedLocale.cs]: "Logistika",
		[SharedLocale.en]: "Logistics",
		[SharedLocale.pl]: "Logistyka",
		[SharedLocale.sk]: "Logistika",
	},
	healthcare: {
		[SharedLocale.cs]: "Zdravotnictví",
		[SharedLocale.en]: "Healthcare",
		[SharedLocale.pl]: "Ochrona zdrowia",
		[SharedLocale.sk]: "Zdravotníctvo",
	},
	industry: {
		[SharedLocale.cs]: "Průmysl",
		[SharedLocale.en]: "Industry",
		[SharedLocale.pl]: "Przemysł",
		[SharedLocale.sk]: "Priemysel",
	},
	engineering: {
		[SharedLocale.cs]: "Strojírenství",
		[SharedLocale.en]: "Engineering",
		[SharedLocale.pl]: "Inżynieria",
		[SharedLocale.sk]: "Strojárstvo",
	},
	foodIndustry: {
		[SharedLocale.cs]: "Potravinářství",
		[SharedLocale.en]: "Food industry",
		[SharedLocale.pl]: "Przemysł spożywczy",
		[SharedLocale.sk]: "Potravinárstvo",
	},
	ecommerce: sameValueForEverySharedLocale("E-commerce"),
	retail: sameValueForEverySharedLocale("Retail"),
	productionSupply: sameValueForEverySharedLocale("Production supply"),
};

export function getLabelName(value: string, locale: SharedLocale): string {
	return referenceScopeLabels[value]?.[locale] ?? referenceUseCaseLabels[value]?.[locale] ?? value;
}
